import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-photos",
  templateUrl: "./med-icon-photos.component.html",
})
export class MedIconPhotosComponent extends SvgMixinComponent {}
